import {
  LastChanceAdminQuery,
  LastChanceCancelResponse,
  LastChanceProductListItem,
  LastChanceProductsResponse,
  LastChanceSalesStatus,
  LastChanceSummary,
} from '@models/last-chance';
import { apiClient } from '.';

const BASE_URL = '/admin/v1/last-chance';

export const getLastChanceSummary = async (params?: LastChanceAdminQuery) => {
  return apiClient.get<LastChanceSummary>(`${BASE_URL}/summary`, { params });
};

export const searchLastChanceProducts = async (params?: LastChanceAdminQuery) => {
  return apiClient.get<LastChanceProductsResponse>(`${BASE_URL}/products`, { params });
};

export const getLastChanceProduct = async (id: string) => {
  return apiClient.get<LastChanceProductListItem>(`${BASE_URL}/products/${id}`);
};

export const getLastChanceSalesStatus = async (id: string) => {
  return apiClient.get<LastChanceSalesStatus>(`${BASE_URL}/products/${id}/sales-status`);
};

export const cancelLastChanceRegistration = async (id: string) => {
  return apiClient.post<LastChanceCancelResponse>(`${BASE_URL}/products/${id}/cancel`);
};

export const exportLastChanceProductsExcel = async (params?: LastChanceAdminQuery) => {
  return apiClient.get(`${BASE_URL}/products/export`, {
    params,
    responseType: 'blob',
    headers: { 'Cache-Control': 'no-cache' },
  });
};
